/** Fired when an HTTP request fails with a non-validation error status (anything but 422). */
export const HTTP_REQUEST_ERROR_EVENT = 'diagonal:http-request-error';

export interface HttpRequestErrorDetail {
  status: number;
  message: string | null;
}
